import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=661c49ca"
import script from "./CompanyCard.vue?vue&type=script&lang=ts"
export * from "./CompanyCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661c49ca')) {
      api.createRecord('661c49ca', component.options)
    } else {
      api.reload('661c49ca', component.options)
    }
    module.hot.accept("./CompanyCard.vue?vue&type=template&id=661c49ca", function () {
      api.rerender('661c49ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyCard.vue"
export default component.exports